import React from 'react';
import ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
// Initialize axe-core for accessibility testing in development mode
if (process.env.NODE_ENV !== 'production') {
    import('@axe-core/react').then((axe) => {
        axe.default(React, ReactDOM, 1000);
    });
}
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
if (!document.title.trim()) {
    document.title = 'CodeReport';
}
ReactDOM.render(<App config={config}/>, target);
